import { render, staticRenderFns } from "./brochure.vue?vue&type=template&id=762927d0&scoped=true"
import script from "./brochure.vue?vue&type=script&lang=js"
export * from "./brochure.vue?vue&type=script&lang=js"
import style0 from "./brochure.vue?vue&type=style&index=0&id=762927d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762927d0",
  null
  
)

export default component.exports